export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7803.7c0a81b1.jpg";